import React from 'react'
import { Route, Switch } from 'react-router-dom'
import CreatePage from './create/create.page'
import EditPage from './edit/edit.page'
import PageDetails from './details/details.page'
import Pages from './pages.page'

const PageController = () => {
    return (
        <Switch>
            <Route path="/content/pages/view/:id" component={PageDetails} />
            <Route path="/content/pages/edit/:id" component={EditPage} />
            <Route path="/content/pages/create" component={CreatePage} />
            <Route exact path="/content/pages" component={Pages} />
        </Switch>
    )
}

export default PageController
